"use client";

import { StoreProvider as EasyPeasyProvider } from "easy-peasy";
import { store } from "./index";

export function StoreProvider({ children }: { children: React.ReactNode }) {
  return <EasyPeasyProvider store={store}>{children}</EasyPeasyProvider>;
}
